// Resources page: content type filters + load more (REST: GET /wp-json/fwp/resources)

jQuery(document).ready(function ($) {
  const $section = $('.resources-list');
  if (!$section.length) return;

  const $grid = $section.find('.resources__grid');
  const $filters = $section.find('.resources__filter');
  const $more = $section.find('.resources__more');
  const $moreBtn = $section.find('.resources__more-btn');
  const endpoint = $grid.data('endpoint');
  if (!endpoint) return;

  const LOADING_DELAY = 150; // show the loading state only for slow requests
  const cache = new Map(); // "type|page" => jqXHR promise of { html, has_more }

  let type = '';
  let page = 1;
  let loading = false;

  // Cached / in-flight request for a type + page
  function request(reqType, reqPage) {
    const key = reqType + '|' + reqPage;

    if (!cache.has(key)) {
      const xhr = $.getJSON(endpoint, {
        type: reqType,
        page: reqPage,
        lang: $grid.data('lang'),
      });
      xhr.fail(function () {
        cache.delete(key); // allow a retry
      });
      cache.set(key, xhr);
    }

    return cache.get(key);
  }

  function prefetch(reqType, reqPage) {
    request(reqType, reqPage || 1);
  }

  function load(nextPage, append) {
    if (loading) return;
    loading = true;

    const timer = setTimeout(function () {
      $section.addClass('is-loading');
    }, LOADING_DELAY);

    request(type, nextPage)
      .done(function (res) {
        const $cards = $(res.html).addClass('is-new');
        if (append) {
          $grid.append($cards);
        } else {
          $grid.empty().append($cards);
        }

        page = nextPage;
        $more.prop('hidden', !res.has_more);

        // the next "load more" click will be instant
        if (res.has_more) prefetch(type, page + 1);
      })
      .always(function () {
        clearTimeout(timer);
        loading = false;
        $section.removeClass('is-loading');
      });
  }

  $filters.on('click', function () {
    const $btn = $(this);
    if ($btn.hasClass('active') || loading) return;

    $filters.removeClass('active').attr('aria-pressed', 'false');
    $btn.addClass('active').attr('aria-pressed', 'true');

    type = String($btn.data('type') || '');
    load(1, false);
  });

  $moreBtn.on('click', function () {
    load(page + 1, true);
  });

  // Prefetch on intent (hover / keyboard focus / touch)
  $filters.on('mouseenter focus touchstart', function () {
    prefetch(String($(this).data('type') || ''));
  });

  // ...and warm every filter in an idle moment after the page has loaded
  function warmUp() {
    $filters.each(function () {
      prefetch(String($(this).data('type') || ''));
    });
    // the unfiltered list is already rendered, only its next page is needed
    if (!$more.prop('hidden')) prefetch('', 2);
  }

  $(window).on('load', function () {
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(warmUp, { timeout: 3000 });
    } else {
      setTimeout(warmUp, 1500);
    }
  });
});
